import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/combineReducer";
import { resolveFranchiseLogoSrc } from "../../../utils/franchise/franchiseSlug";
import { INDEX } from "../../../constants/routes";

type FranchiseLogoProps = {
  className?: string;
  alt?: string;
  /** Logo compacto (sidebar colapsado). */
  compact?: boolean;
  /** Variante blanca para fondos oscuros. */
  variant?: "default" | "light";
  linkToHome?: boolean;
};

const DEFAULT_LOGO = "/images/Logo_Lavorix.png";
const DEFAULT_LOGO_LIGHT = "/images/Logo_Lavorix-blanco.png";
const DEFAULT_LOGO_COMPACT = "/images/LogoPequenio.svg";

export default function FranchiseLogo({
  className = "logo",
  alt,
  compact = false,
  variant = "default",
  linkToHome = true,
}: FranchiseLogoProps) {
  const { branding, slug } = useSelector((state: RootState) => state.franchise);
  const isFranchiseTenant = Boolean(slug) && !branding?.isRoot;
  const franchiseLogo = branding?.logoUrl || branding?.logoFile?.key;

  let fallback = DEFAULT_LOGO;
  if (compact && !isFranchiseTenant) {
    fallback = DEFAULT_LOGO_COMPACT;
  } else if (variant === "light" && !isFranchiseTenant) {
    fallback = DEFAULT_LOGO_LIGHT;
  }

  const src = resolveFranchiseLogoSrc(
    isFranchiseTenant ? franchiseLogo : null,
    fallback,
  );
  const label = alt || branding?.fantasyName || branding?.name || "Lavorix";

  const image = (
    <img
      src={src}
      alt={label}
      className={className}
      onError={(e) => {
        (e.target as HTMLImageElement).src = fallback;
      }}
    />
  );

  if (!linkToHome) return image;

  return (
    <Link to={INDEX} className="logo-link">
      {image}
    </Link>
  );
}
